/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAtan2 } from '../../factoriesAny.js';
export var atan2Dependencies = {
  BigNumberDependencies: BigNumberDependencies,
  DenseMatrixDependencies: DenseMatrixDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createAtan2: createAtan2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAtan2.generated.js
// module id = 1349
// module chunks = 0